import React from 'react'
import Footer from './Footer'
import Navigation from './Navigation'

function Privarcy() {
  return (
    <>
    <Navigation/>
    <div className="container">
    <div className="entry-content wp-block-post-content has-global-padding is-layout-constrained wp-block-post-content-is-layout-constrained">
    <p>Sist oppdatert: 30. januar 2025</p>

    <p>https://norgesocialge.com (“vi,” “vårt” eller “oss”) driver nettstedet https://norgesocialge.com (“Tjenesten”).</p>

    <p>Denne siden forklarer våre retningslinjer for innsamling, bruk og deling av personlig informasjon når du bruker Tjenesten.</p>

    <p>Vi er forpliktet til å beskytte ditt personvern og behandler all personlig informasjon i samsvar med denne personvernerklæringen.</p>

    <p>Vi bruker dine personopplysninger for å levere og forbedre Tjenesten. Ved å bruke Tjenesten samtykker du til innsamling og bruk av informasjon i tråd med disse retningslinjene. Med mindre annet er definert i denne personvernerklæringen, har begrepene samme betydning som i våre vilkår og betingelser, tilgjengelig på https://norgesocialge.com.</p>

    <h2 className="wp-block-heading">Innsamling og bruk av informasjon</h2>

    <p>Når du bruker vår Tjeneste, kan du bli bedt om å oppgi visse personopplysninger for å bli kontaktet eller identifisert. Disse kan inkludere, men er ikke begrenset til:</p>
    <ul>
        <li>Fullt navn</li>
        <li>E-postadresse</li>
        <li>Telefonnummer</li>
    </ul>

    <h2 className="wp-block-heading">Loggdata</h2>

    <p>Vi samler inn informasjon som din nettleser sender når du besøker vår Tjeneste (“Loggdata”). Dette kan inkludere informasjon som IP-adresse, nettlesertype, nettleserversjon, besøkte sider, tidspunkt for besøk og varighet, samt annen diagnostisk data.</p>

    <h2 className="wp-block-heading">Informasjonskapsler</h2>

    <p>Informasjonskapsler (cookies) er små filer som lagres på enheten din og kan inneholde en anonym unik identifikator. Vi bruker informasjonskapsler for å forbedre din opplevelse. Du kan stille inn nettleseren din til å avvise informasjonskapsler, men dette kan begrense visse funksjoner i Tjenesten.</p>

    <h2 className="wp-block-heading">Tredjeparts tjenesteleverandører</h2>

    <p>Vi kan benytte tredjeparts selskaper for å drifte Tjenesten, utføre tjenestefunksjoner eller analysere hvordan Tjenesten brukes. Disse tredjepartene har kun tillatelse til å bruke dine opplysninger for å utføre oppgaver på våre vegne og er bundet av konfidensialitetsavtaler.</p>

    <h2 className="wp-block-heading">Sikkerhet</h2>

    <p>Sikkerheten til dine personopplysninger er viktig for oss. Vi bruker bransjestandard sikkerhetstiltak for å beskytte dine data, men ingen metode for overføring eller lagring av data er helt sikker. Vi streber etter å sikre høyest mulig beskyttelse av dine opplysninger.</p>

    <h2 className="wp-block-heading">Personvern for barn</h2>

    <p>Vår Tjeneste er ikke ment for personer under 18 år. Vi samler ikke bevisst inn personopplysninger fra mindreårige. Dersom du oppdager at et barn har gitt oss personopplysninger, vennligst kontakt oss slik at vi kan slette informasjonen umiddelbart.</p>

    <h2 className="wp-block-heading">Endringer i denne personvernerklæringen</h2>

    <p>Vi kan oppdatere denne personvernerklæringen fra tid til annen. Vi anbefaler brukere å sjekke denne siden regelmessig for eventuelle endringer. Endringer trer i kraft umiddelbart etter publisering.</p>

    <h2 className="wp-block-heading">Dataanalyse</h2>

    <p>Norge Social Casino kan bruke dine personopplysninger til analyseformål for å forstå brukerpreferanser og forbedre brukeropplevelsen. Slike analyser kan omfatte kategorisering av brukeratferd og optimalisering av tjenesten. Noen prosesser kan være automatiserte.</p>

    <h2 className="wp-block-heading">Kontakt oss</h2>

    <p>Hvis du har spørsmål eller bekymringer angående denne personvernerklæringen, vennligst kontakt oss på support@norgesocialge.com.</p>
</div>

</div>

    <Footer/>
    
    </>
  )
}

export default Privarcy